module.exports = __webpack_public_path__ + "img/januca-2016.0ac6f9ac.jpeg";